export default "__VITE_ASSET__48f29eaf__"